export default __webpack_public_path__ + "static/media/shrutiClow.241a18fb.wav";